"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var options = {
    global: {},
    unsafe: false
};
exports.default = options;
//# sourceMappingURL=options.js.map